// @flow
export function limitText(text: string, limit: number): string {
  if(!text)return ""
  if (text.length < limit) return text;

  const shorter = text.substr(0, limit) + "...";
  return shorter;
}
